import { render, staticRenderFns } from "./Floor.vue?vue&type=template&id=453f8fc1"
import script from "./Floor.vue?vue&type=script&lang=js"
export * from "./Floor.vue?vue&type=script&lang=js"
import style0 from "./Floor.vue?vue&type=style&index=0&id=453f8fc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports